import classNames from 'classnames';

export const Left = ({ children, className, ...r }) => {
  const classnames = classNames(
    'left-options flex',
    className
  );

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};
